var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAufnehmen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.374 0C21.631 0.000276386 22.6533 1.04088 22.6533 2.32031V5.21973H27.2119C27.842 5.22003 28.3515 5.73847 28.3516 6.37988V7.54004C28.3515 7.69935 28.2229 7.82987 28.0664 7.83008H25.915L25.0361 26.7881C24.9792 28.0241 23.974 28.9998 22.7598 29H6.5918C5.37381 29 4.37242 28.0278 4.31543 26.7881L3.43555 7.83008H1.28516C1.1285 7.83008 1.00008 7.69947 1 7.54004V6.37988C1.00001 5.73828 1.50929 5.21973 2.13965 5.21973H6.69824V2.32031C6.69824 1.04071 7.72037 0 8.97754 0H20.374ZM6.86523 26.3896H22.4854L23.3477 7.83008H6.00391L6.86523 26.3896ZM11.9648 11.1113C12.517 11.1114 12.9647 11.5592 12.9648 12.1113V22.9326C12.9648 23.4848 12.517 23.9326 11.9648 23.9326H11.4004C10.8482 23.9325 10.4005 23.4848 10.4004 22.9326V12.1113C10.4005 11.5592 10.8483 11.1114 11.4004 11.1113H11.9648ZM17.9492 11.1113C18.5013 11.1114 18.9491 11.5592 18.9492 12.1113V22.9326C18.9491 23.4848 18.5014 23.9325 17.9492 23.9326H17.3848C16.8326 23.9326 16.3849 23.4848 16.3848 22.9326V12.1113C16.3849 11.5592 16.8326 11.1114 17.3848 11.1113H17.9492ZM9.2627 5.21973H20.0889V2.61035H9.2627V5.21973Z",
    fill: "#BA3817"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAufnehmen);
export default __webpack_public_path__ + "static/media/delete_aufnehmen.6c9c04ec08f8311ccab0af9d6cccb4be.svg";
export { ForwardRef as ReactComponent };